import React, { useState, useEffect, useRef } from "react"
import BlobContainer from "./BlobContainer"
import Lottie from "react-lottie-player"
import { gsap, Power3 } from "gsap"

// Assets
import ScrollAnim from "../images/scroll.json"
import SoundAnim from "../images/sound.json"

export default function Header({ isPlaying, audioBtn, getTickets }) {
  let app = useRef(null)
  let lottieWrapper = useRef(null)
  let lottieWrapperTwo = useRef(null)
  const [play, setPlay] = useState(false)
  const [playTwo, setPlayTwo] = useState(false)

  // call this to Disable
  function disableScroll() {
    const body = document.querySelector("body")
    body.classList.add("stop-scrolling")
  }

  // call this to Enable
  function enableScroll() {
    const body = document.querySelector("body")
    body.classList.remove("stop-scrolling")
  }

  useEffect(() => {
    disableScroll()
    let tl = new gsap.timeline({
      paused: false,
      onComplete: () => setPlay(true),
    })
    tl.to(app, {
      opacity: 1,
      duration: 2,
      ease: Power3.easeOut,
    })
    tl.to(lottieWrapper, {
      opacity: 1,
      duration: 2,
      ease: Power3.easeOut,
    })
  }, [])

  const playAnimationOne = () => {
    let tl1 = new gsap.timeline({
      paused: false,
      onComplete: () => setPlayTwo(true),
    })
    tl1.to(lottieWrapper, {
      opacity: 0,
      display: "none",
      duration: 0.2,
      ease: Power3.easeOut,
    })
    tl1.to(lottieWrapperTwo, {
      opacity: 1,
      duration: 2,
      ease: Power3.easeOut,
    })
  }

  const playAnimationTwo = () => {
    const tl2 = new gsap.timeline({
      paused: true,
      onComplete: () => enableScroll(),
    })
    tl2.to(lottieWrapperTwo, {
      opacity: 0,
      display: "none",
      duration: 0.2,
      ease: Power3.easeOut,
    })
    tl2.to(".text-one", {
      opacity: 1,
      y: 0,
      duration: 2,
      ease: Power3.easeOut,
    })
    tl2.to(".text-one", {
      opacity: 0,
      display: "none",
      y: -50,
      duration: 2,
      ease: Power3.easeOut,
    })
    tl2.to(".text-two", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: Power3.easeOut,
    })
    tl2.to(".main-text", {
      opacity: 1,
      duration: 2,
      ease: Power3.easeOut,
    })
    tl2.to(".main-text", {
      opacity: 0,
      display: "none",
      duration: 2,
      ease: Power3.easeOut,
    })
    tl2.to(".main-btns", {
      opacity: 1,
      display: "flex",
      duration: 1,
      ease: Power3.easeOut,
    })
    tl2.play()
  }
  return (
    <div
      className="header-container"
      onClick={audioBtn}
      role="button"
      tabIndex="-1"
      id="header"
      ref={el => (app = el)}
    >
      <BlobContainer isPlaying={isPlaying}></BlobContainer>
      <div className="header-title-container">
        <div className="wrapper">
          <div className="side-text left">LOUD.ARMY</div>
          <div className="content-wrapper">
            <div className="lottie-wrapper" ref={el => (lottieWrapper = el)}>
              <Lottie
                animationData={ScrollAnim}
                loop={false}
                play={play}
                onComplete={playAnimationOne}
              />
            </div>
            <div
              className="lottie-wrapper-main"
              ref={el => (lottieWrapperTwo = el)}
            >
              <Lottie
                animationData={SoundAnim}
                loop={false}
                play={playTwo}
                onComplete={playAnimationTwo}
              />
            </div>
            <div className="text-wrapper">
              <h1 className="text-one">Tap on orb to mute</h1>
              <h1 className="text-two">SOUNDS</h1>
            </div>
            <div className="main-text">
              <h2 className="text-three">UNDERGROUND VIRTUAL</h2>
              <h2 className="text-four">MUSIC FESTIVAL</h2>
            </div>
            <div className="main-btns">
              <button onClick={getTickets}>GET TICKETS</button>
              <button className="glass-btn">ENTER CHALLENGE</button>
            </div>
          </div>
          <div className="side-text right">LOUD.ARMY</div>
        </div>
      </div>
    </div>
  )
}
